import { Loader } from "google-maps";

const API_KEY = "AIzaSyDA1xmyiT6xXKkjxhYm5tPHoW2LL83bQI8";

async function initMap() {
  const myLatLng = {
    lat: Number(window.MAP_MARKER?.lat || 0),
    lng: Number(window.MAP_MARKER?.lng || 0),
  };

  const options = {};
  const loader = new Loader(API_KEY, options);

  const google = await loader.load();
  const mapElement = document.getElementById("map");

  if (!mapElement) return null;

  const map = new google.maps.Map(mapElement, {
    center: myLatLng,
    zoom: 15,
    disableDefaultUI: true,
  });

  new google.maps.Marker({
    position: myLatLng,
    map,
    icon: {
      path: "M226 0.335999C101.352 0.335999 0.391998 101.352 0.391998 225.944C0.391998 276.56 17.056 323.288 45.208 360.928L189.92 611.584C190.76 613.2 191.6 614.808 192.632 616.288L192.952 616.84L193.04 616.792C200.432 627.016 212.328 633.68 226.12 633.68C238.568 633.68 249.416 628.016 256.88 619.288L257.256 619.504L258.688 617.024C260.8 614.176 262.672 611.136 264.024 607.784L405.8 362.2C434.536 324.336 451.608 277.144 451.608 225.944C451.608 101.352 350.648 0.335999 226 0.335999ZM223.768 340.32C162.352 340.32 112.608 290.552 112.608 229.16C112.608 167.776 162.352 118 223.768 118C285.184 118 334.928 167.776 334.928 229.16C334.928 290.544 285.184 340.32 223.768 340.32Z",
      fillColor: "#0077C0",
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 0.07,
      anchor: new google.maps.Point(200, 600),
    },
  });
}

initMap();
